var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuItemHrIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1rem",
    viewBox: "0 0 19 21.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-tie-solid",
    d: "M4.071,5.429A5.429,5.429,0,1,0,9.5,0,5.429,5.429,0,0,0,4.071,5.429Zm4.008,8.491.789,1.315L7.456,20.489l-1.527-6.23a.628.628,0,0,0-.759-.479A6.84,6.84,0,0,0,0,20.412a1.3,1.3,0,0,0,1.3,1.3H17.7a1.3,1.3,0,0,0,1.3-1.3,6.84,6.84,0,0,0-5.17-6.633.634.634,0,0,0-.759.479l-1.527,6.23-1.412-5.255.789-1.315a.677.677,0,0,0-.581-1.026H8.665a.678.678,0,0,0-.581,1.026Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuItemHrIcon);
export default __webpack_public_path__ + "static/media/menu-item-hr-icon.24f65e26aafb46a2daf7393f7170be2b.svg";
export { ForwardRef as ReactComponent };